import React from 'react';
import { TeamMember } from './TeamMember';

const teamMembers = [
  {
    name: "André Rossinot",
    role: "Président",
    imageUrl: "https://cdn-s-www.estrepublicain.fr/images/A4BB9CCE-8F74-4281-A2FE-BC9F5B5C2A14/NW_raw/andre-rossinot-a-nancy-ce-vendredi-4-mars-emmanuel-macron-est-tres-habile-dans-la-maniere-de-gerer-sa-presidence-de-l-union-europeenne-photo-er-alexandre-marchi-1646411417.jpg"
  },
  {
    name: "Malika Dati",
    role: "Secrétaire Générale",
    imageUrl: "https://cdn-s-www.estrepublicain.fr/images/93F74C76-878C-44D6-B619-4B733D4F928C/NW_raw/malika-dati-ainee-de-la-fratrie-dati-un-peu-surprise-mais-pas-tant-que-ca-finalement-photo-alexandre-marchi-1705089938.jpg"
  },
  {
    name: "Frédéric Richard",
    role: "Trésorier",
    imageUrl: "https://cdn-s-www.estrepublicain.fr/images/328b4c2a-ac67-4363-858a-4bb5e2210b8d/NW_raw/frederic-richard-une-personnalite-importante-dans-le-monde-de-l-habitat-1552488864.jpg"
  }
];

export const OrgChart = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {teamMembers.map((member) => (
        <TeamMember key={member.name} {...member} />
      ))}
    </div>
  );
};